<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 md-xsmall-size-50">
        <md-datepicker v-model="filter.startDate" :md-immediately="true">
          <label>Từ ngày</label>
        </md-datepicker>
      </div>
      <div class="md-layout-item md-size-20 md-xsmall-size-50">
        <md-datepicker v-model="filter.endDate" :md-immediately="true">
          <label>Đến ngày</label>
        </md-datepicker>
      </div>
      <div class="md-layout-item md-size-20 md-xsmall-size-50">
        <md-field>
          <label>Thanh toán</label>
          <md-select v-model="filter.paymentMethod">
            <md-option :value="-1">Tất cả</md-option>
            <md-option value="Công nợ">Công nợ</md-option>
            <md-option value="Thu tiền ngay">Thu tiền ngay</md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-20 md-xsmall-size-50">
        <md-field>
          <label>Trạng thái</label>
          <md-select v-model="filter.status">
            <md-option :value="-1">Tất cá</md-option>
            <md-option :value="0">Đơn hàng mới</md-option>
            <md-option :value="1">Đã xác nhận</md-option>
            <md-option :value="2">Đang vận chuyển</md-option>
            <md-option :value="3">Hoàn tất</md-option>
            <md-option :value="4">Đã hủy</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <md-table
      :value="queriedData"
      class="table-hover table-border"
      table-header-color="green"
    >
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="ID" class="table-cell" align="left" md-numeric>
          {{ item.orderId }}
        </md-table-cell>
        <md-table-cell md-label="Ngày tạo" class="table-cell" align="left">
          {{ formatDate(new Date(item.orderDate)).substring(0, 11) }}
        </md-table-cell>
        <md-table-cell
          md-label="Tổng tiền"
          class="table-cell"
          align="left"
          md-numeric
        >
          {{ formatMoney(item.amount) }}
        </md-table-cell>
        <md-table-cell md-label="Mã đại lý" class="table-cell" align="left">
          {{ item.customerCode }}
        </md-table-cell>
        <md-table-cell md-label="Đại lý" class="table-cell" align="left">
          {{ item.customerName }}
        </md-table-cell>
        <md-table-cell md-label="Nhân viên" class="table-cell" align="left">
          {{ item.salerName }}
        </md-table-cell>
        <md-table-cell md-label="Trạng thái" class="table-cell" align="left">
          {{
            item.status === 0
              ? "Đơn hàng mới"
              : item.status === 1
              ? "Đã xác nhận"
              : item.status === 2
              ? "Đang giao"
              : item.status === 3
              ? "Hoàn thành"
              : "Đã hủy"
          }}
        </md-table-cell>
        <md-table-cell md-label="Phương thức" class="table-cell" align="left">
          {{ item.paymentMethod }}
        </md-table-cell>
      </md-table-row>
    </md-table>
    <div style="display: flex; justify-content: flex-end">
      <div class="">
        <p class="card-category">
          Hiển thị từ {{ from + 1 }} tới {{ to }} trong số {{ total }} mục
        </p>
      </div>
      <pagination
        class="pagination-no-border pagination-success"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </pagination>
    </div>
  </div>
</template>
<script>
import { Pagination } from "@/components";
export default {
  components: {
    Pagination,
  },
  props: ["customerSelected", "orderHistory"],
  data() {
    return {
      listPay: [],
      filter: {
        paymentMethod: "Công nợ",
        startDate: null,
        endDate: null,
        salerCode: -1,
        status: -1,
      },
      pagination: {
        perPage: 100,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
    };
  },
  methods: {
    amount(num) {
      return num > 0 ? num : num * -1;
    },
  },
  computed: {
    dataFilter() {
      let a = this.orderHistory;
      if (this.filter.startDate !== null) {
        a = a.filter(
          (item) => item.orderDate >= this.filter.startDate.valueOf()
        );
      }
      if (this.filter.endDate !== null) {
        a = a.filter((item) => item.orderDate <= this.filter.endDate.valueOf());
      }
      if (this.filter.salerCode !== -1) {
        a = a.filter((item) => item.salerCode === this.filter.salerCode);
      }
      if (this.filter.paymentMethod !== -1) {
        a = a.filter(
          (item) => item.paymentMethod === this.filter.paymentMethod
        );
      }
      if (this.filter.status !== -1) {
        a = a.filter((item) => item.status === this.filter.status);
      }
      return a;
    },
    queriedData() {
      return this.dataFilter.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.dataFilter.length;
    },
  },
  // watch: {
  //   filterState() {
  //     let query = this.db
  //       .collection(process.env.VUE_APP_ORDER)
  //       .where("customerCode", "==", this.customerSelected.data.customerId)
  //     if (this.filter.salerCode !== -1) {
  //       query = query.where("salerCode", "==", this.filter.salerCode);
  //     }
  //     if (this.filter.orderDay) {
  //       query = query
  //         .where("orderDay",
  //           "==",
  //           this.formatDate(this.filter.orderDay).substring(0, 11)
  //         );
  //     }
  //     if (this.filter.isPayment !== -1) {
  //       query = query
  //         .where("isPayment", "==", this.filter.isPayment);
  //     }
  //     if (this.filter.status !== -1) {
  //       query = query.where("status", "==", this.filter.status);
  //     }
  //     this.$store.dispatch("FLAG_LOADING", true);
  //     this.listPay = [];
  //     query.get().then(doc => {
  //       doc.forEach(item => {
  //         this.listPay.push({
  //           id: item.id,
  //           data: item.data()
  //         })
  //       })
  //       this.$store.dispatch("FLAG_LOADING", false);
  //     })
  //     .catch(error => {
  //       this.$messageError("Có lỗi! Thử tải lại trang")
  //       console.log(error);
  //       this.$store.dispatch("FLAG_LOADING", false);
  //     })
  //   }
  // }
};
</script>
<style scoped>
.itemPayHistory {
  border: none;
  display: flex;
  justify-content: space-around;
}
.itemPayHistory > p {
  width: 17%;
}
.itemPayHistory:hover {
  background: rgba(95, 158, 160, 0.171);
}
.itemOrderHistory {
  background-color: rgba(179, 199, 124, 0.336);
}

.table-border {
  border: solid rgba(0, 0, 0, 0.178) 1px;
  border-radius: 10px;
}
</style>
